import { isDefined } from '@sgme/fp';
import PQueue from 'p-queue';

/**
 * for each swap tile, trace capture requests can't be in parallel
 * -> push the request in a queue that executes it after all previous requests are done
 *
 * WARNING: to avoid memory leak, the queue has to be removed when the tile is removed
 * or the product type is changed to something other than swap
 */
const swapTradeCaptureQueues = new Map<string, PQueue>();

export const getSwapTradeCaptureQueue = (tileId: string): PQueue => {
  const existingQueue = swapTradeCaptureQueues.get(tileId);

  if (isDefined(existingQueue)) {
    return existingQueue;
  }

  const queue = new PQueue({ concurrency: 1 });

  swapTradeCaptureQueues.set(tileId, queue);

  return queue;
};

export const removeSwapTradeCaptureQueue = (tileId: string): void => {
  swapTradeCaptureQueues.delete(tileId);
};
